<template>
  <section>
    <h3>CONNECTIONS</h3>
    <p class="px-3 pt-2">
      Enjoy all the benefits of your favorite fitness apps by pairing them with
      MyWhoosh. To connect, you may be redirected to third-party apps. Please
      make sure to read their
      <a href="https://mywhoosh.com/privacy-policy" target="_blank">
        Privacy Policy
      </a>
      and
      <a href="https://mywhoosh.com/terms-and-conditions/" target="_blank">
        Terms & Conditions
      </a>
      ,as MyWhoosh isn't responsible for how your data is handled there. Once
      connected, your data syncs automatically—so you can spend less time
      managing and more time riding.
    </p>

    <div class="connection" v-if="userNetworks && !selectedNetwork">
      <div class="row pt-md-3 mt-md-3">
        <section
          class="col-md-4 circle-info"
          v-for="(socialPlatform, index) of socialPlatforms"
          :key="index"
        >
          <img alt="" class="img-fluid" :src="`${socialPlatform.logo}`" :style="socialPlatform.name === 'analogx' ? 'object-fit: contain; padding: 10px;' : ''" />

          <div class="text-center">
            <button
              v-if="userNetworks.includes(socialPlatform.name)"
              class="btn-universal btn-universal-social-disconnect"
              @click="btnSocialHandler(socialPlatform.name, 'rem')"
            >
              Disconnect
            </button>
            <button
              v-else
              class="btn-universal"
              @click="btnSocialHandler(socialPlatform.name, 'add')"
            >
              Connect
            </button>
          </div>
        </section>
      </div>
    </div>

    <xert-authentication
      v-if="selectedNetwork == 'xert'"
      @connectionDone="onConnectionDone"
      @onCancel="onCancel"
    />
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { commonMixin } from "@/mixins/commonMixin";
import XertAuthentication from "./XertAuthentication.vue";
import { fitnessNetworksUtils } from "../../utils/networks";

export default {
  components: { XertAuthentication },
  name: "ProfileSocial",
  props: ["linkedNetworks", "userNetworksData", "isNormalUser"],
  mixins: [commonMixin],

  data() {
    return {
      selectedNetwork: "",
      networks: fitnessNetworksUtils.keys,
      socialPlatforms: fitnessNetworksUtils.networks,
    };
  },

  computed: {
    ...mapGetters("common", ["getTempKey"]),

    userNetworks() {
      if (this.linkedNetworks.length === 0) return [];
      return this.linkedNetworks;
    },
  },

  methods: {
    async btnSocialHandler(account, act) {
      if (act === "add") {
        if (account == "xert") {
          this.selectedNetwork = account;
          return;
        }

        let url = this.networks[account];

        if (account == "whoop") {
          url = `${url}&state=${parseInt(Math.random() * 100000000)}`;
        }
        url = url.replace(/(https?:\/\/.+?)\/\/oauth/, "$1/oauth");

        location.href = url;
      }

      if (act === "terms") {
        const termsUrl = this.terms[account];
        window.open(`${termsUrl}${this.userNetworksData[account]}`, "_blank");
      }

      if (act === "rem") {
        if (
          confirm(`Are you sure you want to remove ${account.toUpperCase()}`)
        ) {
          await this.$store
            .dispatch("user/removeConnection", { account })
            .then((res) => {
              if (res && res.status) {
                const index = this.userNetworks.indexOf(account);
                if (index > -1) {
                  this.userNetworks.splice(index, 1);
                }
              }
            });
        }
      }
    },

    onConnectionDone(res) {
      if (res && res.status) {
        this.userNetworks.push("xert");
      }
      this.selectedNetwork = "";
    },

    onCancel() {
      this.selectedNetwork = "";
    },
  },
};
</script>
